// should become Vid play
export const getIconName: (name: string) => string = (name: string): string => {
	// remove prefix (e.g. media-services/)
	const nameAsArray = name.split('/');
	if (nameAsArray.length > 1) {
		if (nameAsArray[1] === '16' || nameAsArray[1] === '24') {
			// for object icons: e.g. blog/24, where the number denotes the size
			nameAsArray.pop();
		} else {
			nameAsArray.shift();
		}
	}
	let iconName = nameAsArray.join('');

	// replace any hyphens with spaces
	// and capitalise only the first letter
	if (iconName) {
		iconName = iconName.replace(/-/g, ' ');
		//replaced '-' with /-/g. removes all instances of hyphens rather than just the first
		iconName = iconName.charAt(0).toUpperCase() + iconName.slice(1);
	}

	return iconName;
};
